import {Component, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';

@Component({
    selector: 'app-table-filters',
    templateUrl: './table-filters.component.html',
    styleUrls: ['./table-filters.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class TableFiltersComponent implements OnInit, OnDestroy {
    @Input() title: string;
    @Input() routeParams: string[] = [];

    isFiltering = false;

    unsubscribe$ = new Subject();

    constructor(private route: ActivatedRoute, private router: Router) {
    }

    ngOnInit() {
        this.route.queryParamMap
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(params => {
                this.handleParamsChanged(params);
            });
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    handleParamsChanged(params: ParamMap) {
        let isFiltering = false;
        for (const param of this.routeParams) {
            if (params.has(param)) {
                isFiltering = true;
                break;
            }
        }
        this.isFiltering = isFiltering;
    }

    async clearFilters() {
        const queryParams = {};
        this.routeParams.forEach(param => queryParams[param] = null);
        await this.router.navigate([], {
            relativeTo: this.route,
            queryParams,
            queryParamsHandling: 'merge'
        });
    }

}
